import { connect } from 'react-redux';

import { openDialog } from '../../../actions/Dialog';
import { deleteAnswer, fetchMessagesSupportPanel, showHideTicket, supportAnswer } from '../../../actions/AdminPanel';
//import { loadTicketInfo } from '../../../actions/AdminPanel';

import TicketView from '../../../components/AdminPanel/SupportPanel/TicketView/TicketView';
import DialogShowUserData from '../../../containers/DialogShowUserDataWrapper/DialogShowUserDataWrapper';
import DialogConfirmationTicketWrapper from '../../DialogConfirmationTicketWrapper/DialogConfirmationTicketWrapper';

const mapStateToProps = (state) => {
    const isLoggedIn = !!state.currentAccount.spaId;
    
    return ({
        isLoggedIn: isLoggedIn,
        spaId: state.currentAccount.spaId,
        spaUsername: state.currentAccount.spaUsername,

        ticketView: state.adminPanel.ticketView,

        isFetching: state.adminPanel.isFetching,
        isError: state.adminPanel.isError,
    })
}

const mapDispatchToProps = (dispatch) => ({
    fetchMessagesSupportPanel: (ticketId, type) => {
        dispatch(fetchMessagesSupportPanel(ticketId, type))
    },

    onSendAnswer: (data) => {
        dispatch(supportAnswer(data))
    },
    onGetUserData: (ownerId) => {
        dispatch(openDialog(<DialogShowUserData ownerId={ownerId} />))
    },
    onDeleteMessage: (id, ticketId) => {
        dispatch(deleteAnswer(id, ticketId))
    },

    onClickShowOrHiddenTicket: (ticketId, isClosed) => {
        dispatch(showHideTicket(ticketId, isClosed))
    },
    onClickDeleteTicket: (ticketId) => {
        dispatch(openDialog(<DialogConfirmationTicketWrapper id={ticketId} isFastAnswer={false} />))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(TicketView)
